import { correlateApi } from '@/utils/api';
import sentryUtils from '@/utils/3rd-party/sentry';

const apiPath = '/proposals/omni';

export const getPresentations = (comparisonId: string) => {
  try {
    return correlateApi.get(`${apiPath}/`, { params: { comparisonId } });
  } catch (err) {
    sentryUtils.captureError(err as Error);
    throw err;
  }
};

export default {
  getPresentations,
};
